import React, { useState } from 'react';
import { Mail, CheckCircle, Sparkles } from 'lucide-react';

const NewsletterBanner = () => {
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
    }
  };

  return (
    <section className="mb-16 bg-[#F4EFE6] border border-[#E8DFC8] rounded-3xl p-8 sm:p-12 text-center relative overflow-hidden shadow-sm">
      {/* Background Soft Glow Accents */}
      <div className="absolute -top-12 -left-12 w-48 h-48 bg-[#E8DFC8]/30 rounded-full blur-2xl pointer-events-none" />
      <div className="absolute -bottom-12 -right-12 w-48 h-48 bg-[#4A0E17]/5 rounded-full blur-2xl pointer-events-none" />

      <div className="max-w-xl mx-auto relative z-10">
        <div className="inline-flex items-center space-x-1.5 mb-2">
          <Sparkles className="w-3.5 h-3.5 text-[#4A0E17]" />
          <span className="text-[10px] font-serif font-bold tracking-[0.25em] text-[#4A0E17] uppercase">
            Private Insider Access
          </span>
        </div>
        
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-[#4A0E17] tracking-tight">
          Join The Vedhyas Heritage Circle
        </h2>
        
        <p className="text-xs text-[#7A6B5D] mt-2 font-light leading-relaxed">
          Receive exclusive invitations to private loom unveilings, complimentary physical lookbooks, and early access to limited edition silk drapes & heritage jewelry collections.
        </p>

        {!subscribed ? (
          <form
            onSubmit={handleSubmit}
            className="mt-6 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <div className="relative w-full">
              <Mail className="w-4 h-4 text-[#7A6B5D] absolute left-3.5 top-1/2 -translate-y-1/2" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address..."
                className="w-full text-xs pl-10 pr-4 py-3.5 bg-[#FDFBF7] border border-[#E8DFC8] rounded-xl focus:outline-none focus:border-[#4A0E17] text-[#4A0E17] placeholder-[#7A6B5D]/70 shadow-sm"
              />
            </div>
            <button
              type="submit"
              className="w-full sm:w-auto bg-[#4A0E17] hover:bg-[#6B1320] text-[#FDFBF7] text-xs font-serif font-bold uppercase tracking-wider px-7 py-3.5 rounded-xl transition-all duration-300 shadow-md active:scale-95 whitespace-nowrap border border-[#6B1320]"
            >
              Subscribe
            </button>
          </form>
        ) : (
          <div className="mt-6 inline-flex items-center space-x-2 bg-[#FDFBF7] px-5 py-3 rounded-xl border border-[#E8DFC8] text-xs font-serif font-bold text-[#4A0E17] shadow-sm">
            <CheckCircle className="w-4 h-4 text-emerald-700 shrink-0" />
            <span>Welcome to the circle. Exclusive lookbook sent to your inbox!</span>
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsletterBanner;